const Card = {
  props: [
    {
      name: 'title',
      default: '',
      type: 'string',
      desc: '标题'
    },
    {
      name: 'subtitle',
      default: '',
      type: 'string',
      desc: '辅助标题'
    }
  ],
  slots: [
    {
      name: 'title',
      desc: '自定义标题'
    },
    {
      name: 'subtitle',
      desc: '自定义辅助标题'
    },
    {
      name: 'extra',
      desc: '头部额外内容'
    }
  ]
}

export default [
  {
    name: 'Card API',
    content: Card
  }
]
